export const signRequestMoveModalId = 'signRequestMoveModal';
export const signRequestPreviewUpdateModalId = 'signRequestPreviewUpdateModal';
export const signRequestAlertId = 'signRequestAlert';
export const signRequestDetachModalId = 'signRequestDetachModal';
export const signRequestDeleteModalId = 'signRequestDeleteModal';
export const signRequestInPortalModalId = 'signRequestInPortalModal';
export const signRequestRestoreModalId = 'signRequestRestoreModal';
export const signRequestEmailModalId = 'signRequestEmailModal';
export const signRequestMetadataModalId = 'signRequestMetadataModal';
export const signRequestCreateModalId = 'signRequestCreateModal';
export const signRequestFilterFormId = 'signRequestFilterForm';
export const signRequestArchiveModalId = 'signRequestArchiveModal';
export const signRequestArchiveAlertId = 'signRequestArchiveAlert';
export const signRequestsExportModalId = 'signRequestsExportModal';
